export default __webpack_public_path__ + "static/media/frame_th_pc.e00c9445.png";